import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "26",
  fill: "none",
  viewBox: "0 0 25 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M20.64 10.183C20.64 5.657 17 2 12.523 2c-4.476 0-8.117 3.657-8.117 8.183v9.016H3.383c-.365 0-.715.147-.975.408-.26.262-.408.619-.408.993l.007.138c.032.323.172.625.4.855.26.262.611.407.976.407h18.234c.365 0 .716-.145.976-.407a1.41 1.41 0 0 0 .004-1.982 1.38 1.38 0 0 0-.967-.412l-.99-.009zm2 7.175a3.4 3.4 0 0 1 1.383.851 3.41 3.41 0 0 1-.012 4.793 3.38 3.38 0 0 1-2.394.998H3.383c-.9 0-1.76-.36-2.395-.998a3.4 3.4 0 0 1-.984-2.234L0 20.6c0-.9.355-1.764.988-2.402a3.4 3.4 0 0 1 1.418-.854v-7.161C2.406 4.566 6.93 0 12.523 0S22.64 4.566 22.64 10.183zM12.455 26c1.665 0 3.045-.774 3.045-2h-6c0 1.226 1.29 2 2.955 2"
    }, null, -1)
  ]))]))
}
export default { render: render }